import {JobOpeningBase} from 'model/jobOpeningBase';

export const Job = JobOpeningBase.extend({
    _name: 'Job',
    urlRoot: '/control/partner/jobs/[id]',
})
